import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

// Thunk para criar o User chamando a API
export const createSingleUser = createAsyncThunk(
    "user/createSingleUser",
    async ({ userName, userEmail, userPassword, isAdmin, approved, selectedRole, selectedDashboardsFilter, selectedGroups }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userName, userEmail, userPassword, isAdmin, selectedRole, approved, selectedDashboardsFilter, selectedGroups }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao salvar User");

            return data; // Retorna os dados salvos para o Redux
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk para buscar um usuário pelo ID
export const fetchUserById = createAsyncThunk("user/fetchUserById", async (id) => {
    const response = await fetch(`${API_URL}/user/user/${id}`);
    if (!response.ok) throw new Error("Erro ao buscar usuários");
    return response.json();
});

// Thunk para resetar passwrod
export const resetPassword = createAsyncThunk(
    "user/resetPassword",
    async ({ email }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/auth/resetPassword`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao resetar Password");

            return data; // Retorna os dados salvos para o Redux
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk para atualizar um usuário existente
export const updateSingleUser = createAsyncThunk(
    "user/updateSingleUser",
    async ({ id, userName, userEmail, isAdmin, approved, selectedRole, selectedDashboards, selectedGroups }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user/${id}`, {
                method: "PUT", // Ou PATCH, dependendo da sua API
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userName, userEmail, isAdmin, approved, selectedRole, selectedDashboards, selectedGroups }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao atualizar User");

            return data; // Retorna os dados atualizados para o Redux
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk para deletar um usuário
export const deleteSingleUser = createAsyncThunk(
    "user/deleteSingleUser",
    async (uid, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/user/user/${uid}`, {
                method: "DELETE",
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Erro ao deletar usuário");

            return uid; // Retorna apenas o UID deletado para o reducer remover da lista
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);